import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';

import type { User } from '@models';

/**
 * `TableCellUserStatus` properties.
 */
export interface Props {
  item: User;
}


declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    TableCellUserStatus: ComponentWithProps<Props>;
  }
}

const __default__ = { name: 'TableCellUserStatus' };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    item: null
  },
  setup(__props: any) {

const props = __props as {
  item: User;
};



const deleting = computed(() => {
  return !!props.item.deletedAt;
});

const blocked = computed(() => {
  return !props.item.active;
});

const deletedAtText = computed(() => {
  let text;

  if (props.item.expires) {
    const deletionDate = new Date(props.item.expires * 1_000).toLocaleString();

    text = `User has been marked for deletion and will be permanently deleted on ${deletionDate}.`;
  } else {
    text = 'User has been marked for deletion.';
  }

  return text;
});

return { __sfc: true,props, deleting, blocked, deletedAtText }
}

})